import { compareAsc, compareDesc } from 'date-fns';
import { parseDate } from './parse-date';

export const compareAscending = (date1: string | Date, date2: string | Date) =>
  compareAsc(parseDate(date1), parseDate(date2));
export const compareDescending = (date1: string | Date, date2: string | Date) =>
  compareDesc(parseDate(date1), parseDate(date2));
